<template>
    <!--猜你喜欢-->
    <div class="recommend-wrapper" v-if="productList.length > 0">
        <h3 class="recommend-title">猜你喜欢</h3>
        <ul class="recommend-content">
            <li class="recommend-item" v-for="item in productList" :key="item.id">
                <a :href="`/proDetail_1217.html?prodId=${item.id}`">
                    <div class="product-img">
                        <img v-lazy="item.image">
                    </div>
                    <div class="product-info">
                        <h4 class="brand-name">{{item.showBrand}}</h4>
                        <p class="product-name">{{item.name}}</p>
                        <p class="product-price"><span>￥{{item.secooPrice}}</span><span class="price-tag" :data-tag="item.priceTag" v-show="item.priceTag">{{item.priceTag}}</span></p>
                        <p class="product-del-price" v-show="item.tipPrice"><del>￥{{item.tipPrice}}</del></p>
                        <p class="product-tags">{{item.tags.join('&nbsp;|&nbsp;')}}</p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import {api_getRecommendProducts} from '@/api';

    const SEC = require('common/js/utils/core.js');

    export default {
        name: '',
        data () {
            return {
                productList: [],
                cvs: null,
                ctx: null
            };
        },
        created () {
            const that = this;
            that._getRecommendProductsList();
            that.cvs = document.createElement('canvas');
            that.ctx = that.cvs.getContext('2d');
        },
        methods: {
            // 获取推荐商品列表
            _getRecommendProductsList () {
                const that = this;

                api_getRecommendProducts().then(({data}) => {

                    const {retCode, productList} = data;
                    if (retCode === 0) {
                        productList.forEach(item => {
                            const {picUrl, tags, secooPrice, tipPrice} = item;
                            // item.image = `//pic.secoo.com/product/374/374/${picUrl}`; // 处理图片
                            item.image = picUrl; // 处理图片
                            item.tags = Array.isArray(tags) ? tags : []; // 处理商品的tags（如果没有tags，后端返回的是空对象，不是空数组）
                            item.secooPrice = SEC.number.currency(secooPrice); // 价格货币化加工
                            item.tipPrice = SEC.number.currency(tipPrice); // 价格货币化加工
                        });
                        that.productList = productList;
                        that.$nextTick(function () {
                            const tagEle = document.querySelector('.product-tags');
                            const tagEleWidth = tagEle.offsetWidth;
                            that.ctx.font = window.getComputedStyle(tagEle).getPropertyValue('font');
                            that.productList.forEach(item => {
                                item.tags = that._getTagText(item.tags, tagEleWidth);
                            });
                            delete that.cvs;
                            delete that.ctx;
                        });
                    }
                });
            },
            _getTagText (tags, tagEleWidth) {
                const that = this;
                if (that.ctx.measureText(tags.join(' | ')).width <= tagEleWidth + 1) {
                return tags;
                } else {
                tags.splice(tags.length - 2, 1);
                return that._getTagText(tags, tagEleWidth);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.recommend-wrapper {
    background-color: #fff;
    color: $color-black;
    overflow: hidden;
    .recommend-title {
        padding: toRem(40) toRem(30);
        font-size: toRem(30);
        line-height: toRem(42);
        font-weight: 700;
        background-color: #fff;
    }
    .recommend-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .recommend-item {
            width: toRem(373);
            margin-bottom: toRem(60);
            .product-img {
                width: toRem(374);
                height: toRem(374);
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .product-info {
            height: toRem(224);
            margin-top: toRem(50);
            padding: 0 toRem(30);
            .brand-name {
                margin-bottom: toRem(8);
                font-family: Futura-Medium;
                font-size: toRem(24);
                line-height: toRem(32);
                overflow: hidden;
                @extend %text-ellipsis;
            }
            .product-name {
                margin-bottom: toRem(20);
                font-family: PingFangSC-Light;
                font-size: toRem(24);
                line-height: toRem(33);
                overflow: hidden;
                @extend %text-ellipsis;
            }
            .product-price {
                display: flex;
                align-items: center;
                height: toRem(48);
                line-height: toRem(48);
                margin-bottom: toRem(4);
                vertical-align: middle;
                overflow-x: hidden;
                @extend %text-ellipsis;
                span {
                    &:first-child {
                        font-family: Futura-Medium;
                        font-size: toRem(34);
                        color: #000B0B;
                        overflow-x: hidden;
                        @extend %text-ellipsis;
                    }
                }
                .price-tag {
                    position: relative;
                    height: toRem(30);
                    margin-left: toRem(16);
                    padding: 0 toRem(6);
                    background-color: $color-yellow;
                    font-family: PingFangSC-Regular;
                    font-size: toRem(20);
                    color: transparent;
                    line-height: toRem(30);
                    box-sizing: border-box;
                    /*解决在部分安卓手机下设置字体垂直居中后偏上的问题*/
                    &:after {
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: attr(data-tag);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 200%;
                        height: 200%;
                        font-size: toRem(40);
                        transform-origin: 0 0;
                        transform: scale(0.5);
                        color: #FFFFFF;
                    }
                }
            }
            .product-del-price {
                line-height: toRem(32);
                font-family: Futura-Medium;
                font-size: toRem(24);
                color: #CCCCCC;
            }
            .product-tags {
                display: flex;
                align-items: center;
                height: toRem(33);
                margin-top: toRem(14);
                line-height: toRem(33);
                color: #8B572A;
                font-family: PingFangSC-Light;
                font-size: toRem(24);
                white-space: nowrap;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MRecommend/index.vue